import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { UnsubscribeBase } from '../base';
import { LOCAL_STORAGE } from '../constants';

@Injectable()
export class NavigationService extends UnsubscribeBase {
  private router = inject(Router);

  private isFirstNavigation = true;

  initializeNavigation(hasValidAccessToken: boolean) {
    this.addSubscription = this.router.events.subscribe((event) => {
      if (
        this.isFirstNavigation &&
        !hasValidAccessToken &&
        event instanceof NavigationStart
      ) {
        localStorage.setItem(LOCAL_STORAGE.NAVIGATION_URL, event.url);
        this.isFirstNavigation = false;
      }
    });
  }

  async handleNavigationAfterLogin() {
    const firstNavigationUrl = localStorage.getItem(
      LOCAL_STORAGE.NAVIGATION_URL,
    );
    if (firstNavigationUrl) {
      await this.router.navigateByUrl(firstNavigationUrl || '/');
      localStorage.removeItem(LOCAL_STORAGE.NAVIGATION_URL);
    }
    return Promise.resolve();
  }
}
